import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInput from '../basic/TextInput';
import MaskedTextInput from './MaskedTextInput';
import SelectInput from '../basic/SelectInput';
import LOOKUP from 'constants/lookup';

class AddressInfo extends Component {
    render() {
        const p = this.props;
        const countries = LOOKUP.common.country.options;
        if (!countries) return null;
        const countryRegions = LOOKUP.common.country.regions.filter(c => c.code == p.selectedCountry || 'CA');

        let dialogClass = this.props.isDialog ? 'col-lg-12' : 'col-lg-6';

        return (
            <div className="row">
                <div className="col-lg-12">
                    <TextInput name={`${p.name}Address`} floatingLabelText="Address" fullWidth={true} hintText="Address"
                               maxLength={150} />
                </div>
                <div className={dialogClass}>
                    <SelectInput
                        name={p.name + 'Country'}
                        fullWidth={true}
                        label="Country"
                        floatingLabelText="Country"
                        hintText="Country"
                        defaultValue="CA"
                        options={countries} required />
                </div>
                <div className={dialogClass}>
                    <SelectInput
                        name={p.name + 'ProvinceState'}
                        fullWidth={true}
                        label={LOOKUP.common.state.label}
                        floatingLabelText={LOOKUP.common.state.label}
                        hintText={LOOKUP.common.state.hintText}
                        defaultValue={p.defaultProvince}
                        options={countryRegions} required />
                </div>
                <div className={dialogClass}>
                    <TextInput name={`${p.name}City`} floatingLabelText="City" fullWidth={true} hintText="City"
                               maxLength={50} />
                </div>
                <div className={dialogClass}>
                    <MaskedTextInput fullWidth={true} name={`${p.name}PostalCode`} floatingLabelText="Postal code"
                                     mask="A9A 9A9" className="text-right" />
                </div>
        </div>)

    }
}

const mapStateToProps = (state, props) => {
    let defaultValue = state.common.store.provinceState == "ON" || state.common.store.provinceState == "Ontario" ? "ON" :
        state.common.store.provinceState == "BC" || state.common.store.provinceState == "British Columbia" ? "BC" :
            state.common.store.provinceState == "AB" || state.common.store.provinceState == "Alberta" ? "AB" :
                state.common.store.provinceState == "MB" || state.common.store.provinceState == "Manitoba" ? "MB" :
                    state.common.store.provinceState == "SK" || state.common.store.provinceState == "Saskatchewan" ? "SK" : "BC";
    return {
        selectedCountry: state.form[props.name + 'Country'],
        selectedRegions: state.form[props.name + 'ProvinceState'],
        defaultProvince: defaultValue
    };
};

export default connect(mapStateToProps)(AddressInfo);
